// Return type for SetErrorHandlerAction

export interface SetErrorHandlerReturn {
    type: string;
    payload: { status?: number | null; data?: any };
}

export interface SetErrorHandlerAction {
    (error: { status?: number | null; data?: any }): SetErrorHandlerReturn;
}

export const setErrorHandlerAction: SetErrorHandlerAction = (error) => {
    return {
        type: 'ERROR_HANDLER',
        payload: error,
    };
};

export interface ShowMessageReturn {
    type: string;
    payload: { messageType?: string; message?: string };
}

export interface ShowMessageAction {
    (error: { messageType?: string; message?: string; options?: object }): ShowMessageReturn;
}

export const showMessageAction: ShowMessageAction = (message) => {
    return {
        type: 'MESSAGE_HANDLER',
        payload: message,
    };
};

// Return type for SetSystemLoadingAction
export interface SetSystemLoadingReturn {
    payload: boolean;
    type: string;
}

export interface SetSystemLoadingAction {
    (loading: boolean): SetSystemLoadingReturn;
}

export const setSystemLoadingAction: SetSystemLoadingAction = (loading) => {
    return {
        type: 'SET_SYSTEM_LOADING',
        payload: loading,
    };
};

// Return type for ShowSystemErrorAction
export interface ShowSystemErrorReturn {
    payload: boolean;
    type: string;
}

export interface ShowSystemErrorAction {
    (error?: boolean): ShowSystemErrorReturn;
}

export const showSystemErrorAction: ShowSystemErrorAction = (error = true) => {
    return {
        type: 'SHOW_SYSTEM_ERROR',
        payload: error,
    };
};
